import { message } from 'antd';
import { BULK_UPDATE_TRIP_VEHICLE_INFO_URL } from './../../utils/api-url';
import { postCall } from '../../utils/network.util';
import { isValid, isValidArray } from '../../utils/utilities';

/*
    Map schedule search results (from the shared fetchSchedules / /api/schedules
    action) into editable rows for the bulk vehicle update table. Each schedule
    carries the trip along with its current vehicle & driver details; one row per
    trip.
*/
export const mapSchedulesToRows = (schedules) => {
    if (!isValidArray(schedules)) {
        return [];
    }
    let seen = {};
    let rows = [];
    schedules.forEach((item) => {
        if (!isValid(item) || !isValid(item.trip) || !isValid(item.trip.id)) {
            return;
        }
        if (seen[item.trip.id]) {
            return;
        }
        seen[item.trip.id] = true;
        rows.push({
            id: item.trip.id,
            schedule_id: item.schedule_id,
            start_date: item.trip.start_date,
            start_time: item.start_time,
            description: item.description,
            origin: item.origin,
            destination: item.destination,
            bus_id: item.bus_id,
            vechicle_id: item.vechicle_id,
            phone_no: item.phone_no,
            driver_name: item.driver_name,
            second_driver_name: item.second_driver_name,
            second_driver_phone_no: item.second_driver_phone_no,
            conductor_name: item.conductor_name,
            conductor_phone: item.conductor_phone,
            trip_instruction: item.trip_instruction
        });
    });
    return rows;
};

/*
    Bulk update vehicle & driver details for many trips in a single request.
    `trips` is an array of trip payloads matching the single-trip update shape.
*/
export const bulkUpdateTripVehicleInfo = (trips, onSuccess = () => { }, onFailure = () => { }) => {
    postCall(BULK_UPDATE_TRIP_VEHICLE_INFO_URL, { trips })
        .then((findresponce) => {
            if (findresponce.status === "SUCCESS" && findresponce.payload.Status === "SUCCESS") {
                let payload = findresponce.payload.Payload || {};
                if (payload.failedCount > 0) {
                    message.warning(findresponce.payload.Message);
                } else {
                    message.success(findresponce.payload.Message);
                }
                onSuccess(payload);
            } else {
                onFailure();
                if (findresponce.status === "SUCCESS") {
                    message.error(findresponce.payload.Message);
                } else {
                    message.error("Failed to update trips!");
                }
            }
        });
};
